import { useAppStore } from "../stores/useAppStore";
import { toUrlFriendly } from "../utils/utils";
import AnalyticsWrapper from "./AnalyticsWrapper";
import Button from "./Button";
import IconArrow from "./IconArrow";

export default function CardKeyDemoBig({item, className= ''}) {
    const { openViewer } = useAppStore((state) => state.viewer);
    const { setCardTouchPos } = useAppStore();

    const handleButtonClick = (event, product) => {
        event.preventDefault();
        event.stopPropagation();
        
        let x, y;

        // Para eventos táctiles, usar changedTouches en lugar de touches
        if (event.changedTouches && event.changedTouches.length > 0) {
            // Evento táctil
            x = event.changedTouches[0].clientX;
            y = event.changedTouches[0].clientY;
        } else if (event.touches && event.touches.length > 0) {
            // Evento táctil alternativo
            x = event.touches[0].clientX;
            y = event.touches[0].clientY;
        } else {
            // Evento de ratón
            x = event.clientX;
            y = event.clientY;
        }
        
        setCardTouchPos({x, y});

        openViewer(product);
    };

    return (
        <div className={`grid grid-cols-2 landscape:grid-cols-3 auto-rows-min gap-x-113u gap-y-108u rounded-50u border-2u border-[#e2e2e2] bg-[#0E2242] w-full place-content-start
            px-150u pt-243u
        ${className}`}>
            
            <div className="
                absolute
                top-105u left-173u
                text-45u leading-none text-silver"
                >Products / solutions featured</div>

            {item.products.map((product, i) => (
                <Button
                    key={i}
                    onClick={(event) => handleButtonClick(event, product)}
                    className="click-effect pl-84u pr-77u
                    h-186u w-full
                    justify-between
                    text-36u leading-42u
                    text-left
                    bg-[#0E2242]"
                    >
                    <div dangerouslySetInnerHTML={{ __html: product.title || '' }}></div>
                    <IconArrow className="w-18u h-auto" />
                </Button>
            ))}
        </div>
    );
};